export interface PartialWindow {
  readonly location: Pick<Location, 'href'>;
  readonly matchMedia: Window['matchMedia'];
  readonly download: (uri: string, saveAs?: string) => void;
  readonly close: () => void;
}
